import React, { useEffect, useState, useMemo } from 'react'
import AuthLayout from '../../components/auth/AuthLayout'
import LoginForm from '../../components/auth/LoginForm'
import { login } from '../../server/server'
import { getSSOLoginUrl } from '../../server/sso'
import { useHistory } from 'react-router-dom'
import { logLoginTime } from '../../server/usersData'
import { usePageTitle } from '../../utils/util'
import { useCompleteLogin } from '../../hooks/useCompleteLogin'
import { useSSOError } from '../../components/auth/ssoErrors'

const LoginScreen = () => {
    usePageTitle(`Upstrive Education - Login`)
    const history = useHistory()
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const [ssoProviderLoading, setSSOProviderLoading] = useState(null)
    const [errorMessage, setErrorMessage] = useState('')
    const completeLogin = useCompleteLogin()
    const [ssoErrorMessage, clearSSOError] = useSSOError()

    useEffect(() => {
        // Returning with the browser back button restores this page from the bfcache with the
        // SSO button still in its loading state.
        const resetSSOLoading = (event) => event.persisted && setSSOProviderLoading(null)
        window.addEventListener('pageshow', resetSSOLoading)
        return () => window.removeEventListener('pageshow', resetSSOLoading)
    }, [])

    const disabled = useMemo(() => {
        return !email || !password
    }, [email, password])

    const loginUser = async ({ email, password }) => {
        setIsLoading(true)
        setErrorMessage('')
        clearSSOError()

        const startTime = Date.now()
        const resp = await login({ email, password })
        const endTime = Date.now()

        const logLoginTimeData = {
            start_time: startTime,
            end_time: endTime,
            device: 'desktop',
            success: resp.status === 200,
            user_id: resp?.data?.id,
            email: email,
            serverError: 500 <= resp.status && resp.status < 599,
        }
        logLoginTime(logLoginTimeData)

        if (resp.status === 200) {
            const redirectedToStudent = await completeLogin(resp.data)
            if (redirectedToStudent) {
                setErrorMessage("You will be redirected to student's page...")
            }
        } else {
            setErrorMessage(resp.data)
        }

        setIsLoading(false)
    }

    const loginWithSSO = (provider) => {
        setSSOProviderLoading(provider)
        clearSSOError()
        window.location.assign(getSSOLoginUrl(provider, email))
    }

    const handleForgotPassword = () => {
        history.push('/auth/forgot-password')
    }

    return (
        <AuthLayout>
            <LoginForm
                email={email}
                setEmail={setEmail}
                password={password}
                setPassword={setPassword}
                onSubmit={loginUser}
                onForgotPassword={handleForgotPassword}
                onSSOLogin={loginWithSSO}
                ssoProviderLoading={ssoProviderLoading}
                isLoading={isLoading}
                errorMessage={errorMessage || ssoErrorMessage}
                disabled={disabled}
            />
        </AuthLayout>
    )
}

export default LoginScreen
